import { render, staticRenderFns } from "./StudentInfos.vue?vue&type=template&id=25c35b36&"
import script from "./StudentInfos.vue?vue&type=script&lang=js&"
export * from "./StudentInfos.vue?vue&type=script&lang=js&"
import style0 from "./StudentInfos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports